import { render, staticRenderFns } from "./DocsDownloads.vue?vue&type=template&id=f3283e26&"
import script from "./DocsDownloads.vue?vue&type=script&lang=js&"
export * from "./DocsDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports